const SANITY_QUERY_URL = "https://eg3wgh61.apicdn.sanity.io/v2025-02-19/data/query/production"

// Not the app's axios instance: its case conversion would rename Portable Text's _type and _key
const sanityQuery = async <T>(query: string): Promise<T> => {
  const response = await fetch(
    `${SANITY_QUERY_URL}?query=${encodeURIComponent(query)}&returnQuery=false`,
    { signal: AbortSignal.timeout(10_000) },
  )
  if (!response.ok) {
    throw new Error(`Sanity query failed with ${response.status}`)
  }
  const { result }: { result: T } = await response.json()

  return result
}

export default sanityQuery
